import React, { useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import Swal from "sweetalert2";
import * as api from "../../common/manipurCommon/API";

const Registration = () => {

    const routes = all_routes;
    const navigate = useNavigate();
    const formRef = useRef(null);

    const [email, setEmail] = useState('');
    const [showModal, setShowModal] = useState(false);

    function mailVerify() {
        setShowModal(true)
    }

    function verifyEmail(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            const formData = new FormData();
            formData.append("email", email)
            const emailVerify = api.RegisterEmailVerify;
            fetch(emailVerify, {
                method: "POST",
                body: formData
            })
                .then((response) => response.json())
                .then((result) => {
                    if (result.error == false) {
                        localStorage.setItem("athleteId", result.data.athleticId);
                        localStorage.setItem("onboardstep", result.data.onboardStep)
                        Swal.fire({
                            title: 'Success',
                            text: result.message,
                            icon: 'success',
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        }).then((res) => {
                            if (res.isConfirmed) {
                                setShowModal(false)
                                navigate(routes.manipurAthletes)
                            }
                        });
                    } else {
                        Swal.fire({
                            title: 'Error',
                            text: result.message,
                            icon: 'error',
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        })
                    }
                })
        }
    }

    return (
        <>
            <div className="content container">
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row justify-content-center">
                                <div className="col-lg-6 d-flex">
                                    <div className="work-grid w-100">
                                        <div className="work-icon">
                                            <div className="work-icon-inner">
                                                <ImageWithBasePath
                                                    src="assets/img/icons/work-icon1.svg"
                                                    alt="Icon"
                                                />
                                            </div>
                                        </div>
                                        <div className="work-content">
                                            <h5>
                                                <Link to="#" onClick={mailVerify}>Continue Registration</Link>
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 d-flex">
                                    <div className="work-grid w-100">
                                        <div className="work-icon">
                                            <div className="work-icon-inner">
                                                <ImageWithBasePath
                                                    src="assets/img/icons/work-icon1.svg"
                                                    alt="Icon"
                                                />
                                            </div>
                                        </div>
                                        <div className="work-content">
                                            <h5>
                                                <Link to={routes.manipurAthletes} onClick={()=>localStorage.clear()}>New Registration</Link>
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {showModal && (
                <Modal
                    show={showModal}
                    size="md"
                    centered>
                    <ModalHeader>
                        <ModalTitle>
                            <h4 className="mb-0 upper-case">Email Verify</h4>
                        </ModalTitle>
                        <Button
                            variant=""
                            className="btn-close"
                            onClick={() => setShowModal(false)}
                        ></Button>
                    </ModalHeader>
                    <ModalBody>
                        <form ref={formRef}>
                            <div className="col-lg-12 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Email</label>
                                    <input
                                        type="email"
                                        className="form-control"
                                        id="email"
                                        placeholder="Enter Email"
                                        required
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                </div>
                            </div>
                        </form>
                        <ModalFooter>
                            <Button
                                className="btn-primary text-uppercase"
                                variant="success"
                                type="submit"
                                onClick={verifyEmail}
                            >
                                <b><i className="fas fa-save" />Save</b>
                            </Button>
                        </ModalFooter>
                    </ModalBody>
                </Modal >
            )}
        </>
    );
};

export default Registration;